import { enableProdMode } from '@angular/core';

if (window.location.hostname.toLowerCase().indexOf('lo-', 0) < 0) {
    enableProdMode();
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../environment.ts